// extracted by mini-css-extract-plugin
module.exports = {"ingredientContainer":"ingredient-icon-round_ingredientContainer__3xYVr","ingredientImg":"ingredient-icon-round_ingredientImg__3mktB"};